<dx-button text="Search Now" (click)="btnClick.emit()" [disabled]="disabled" [useSubmitBehavior]="true" style="height: 26px !important;"></dx-button>
